import * as React from 'react';
import PropTypes from 'prop-types';
import { useSelector } from 'react-redux';
import { useNavigate, useParams } from 'react-router-dom';

import LanguageConverterV2 from '@careerstart/wae-common/src/main/helperFunction/LanguageConverterV2';
import { Box, Typography } from '@mui/material';

import FormCloseButton from '../../../../components/Form/FormCloseButton';
import { selectAgencyDetail } from '../../../../store/selectors/dashboardSelector';
import { BLACK, PRIMARY_PURPLE } from '../../../../theme/colorConstants';
import { PRIMARY_FONT } from '../../../../theme/fontConstants';
import { ROUTE_CONSTANTS } from '../../../app/RouteBuilding/routeConstants';

import AgencyCorporationEditPage from './AgencyCorporationEditPage';
import AgencyDetailEditPage from './AgencyDetailEditPage';

const AGENCY_EDIT_VIEWS = {
  DETAIL: 'detail',
  CORPORATION: 'corporation',
};

const AgencyEditView = () => {
  const { id } = useParams();
  const [activeView, setActiveView] = React.useState(AGENCY_EDIT_VIEWS.DETAIL);

  const navigate = useNavigate();
  const agencyDetail = useSelector(selectAgencyDetail);

  const handleGoBackClick = (agencyId) => {
    navigate(`/${ROUTE_CONSTANTS.DASHBOARD_AGENCY}/${agencyId}`);
  };

  return (
    <Box sx={{ borderRadius: '8px', gap: '8px', padding: '30px' }}>
      <>
        <Box sx={{ display: 'flex', alignItems: 'center', gap: 2 }}>
          <FormCloseButton onClose={() => handleGoBackClick(id)} message="buttonText.goBack" />
          <Typography
            onClick={() => setActiveView(AGENCY_EDIT_VIEWS.DETAIL)}
            sx={{
              fontSize: '18px',
              fontFamily: PRIMARY_FONT[300],
              marginLeft: '16px',
              cursor: 'pointer',
              color: activeView === AGENCY_EDIT_VIEWS.DETAIL ? BLACK[70] : PRIMARY_PURPLE[70],
            }}
          >
            {LanguageConverterV2('dashboard.agency.edit.agencyDetail')}
          </Typography>
          <Typography
            onClick={() => setActiveView(AGENCY_EDIT_VIEWS.CORPORATION)}
            sx={{
              fontSize: '18px',
              fontFamily: PRIMARY_FONT[300],
              marginLeft: '16px',
              cursor: 'pointer',
              color: activeView === AGENCY_EDIT_VIEWS.CORPORATION ? BLACK[70] : PRIMARY_PURPLE[70],
            }}
          >
            {LanguageConverterV2('dashboard.agency.edit.addEditCorporations')}
          </Typography>
        </Box>
        <Box>
          <Box
            sx={{
              display: 'flex',
              flexDirection: 'column',
              pt: '24px',
            }}
          >
            <Typography sx={{ fontFamily: PRIMARY_FONT[700], fontSize: '24px' }}>
              {agencyDetail?.name}
            </Typography>
            <Typography sx={{ fontFamily: PRIMARY_FONT[300], fontSize: '12px' }}>
              {`${LanguageConverterV2('dashboard.agencies.edit.onboardingIdNumber')} ${
                agencyDetail?.onboardingId
              }`}
            </Typography>
          </Box>

          {activeView === AGENCY_EDIT_VIEWS.CORPORATION ? (
            <AgencyCorporationEditPage />
          ) : (
            <AgencyDetailEditPage />
          )}
        </Box>
      </>
    </Box>
  );
};
AgencyEditView.propTypes = {
  styles: PropTypes.shape({}),
};
export default AgencyEditView;
